import React from 'react';
import { FormGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';

import * as types from '../../reducer/constants';

const FieldIgnoreCompletedStatus = ({ form, dispatchServiceData }) => {
  const { auto_complete_ignore_provider } = form;

  const onChange = () => {
    const value = !auto_complete_ignore_provider;
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_AUTO_COMPLETE_IGNORE_PROVIDER, value })
  };

  return (
    <>
      <FormGroup>
        <div className="checkbox">
          <label>
            <input
              type="checkbox"
              checked={auto_complete_ignore_provider}
              onChange={onChange}
            />
            <strong>Ignore Completed status from provider</strong>
          </label>
        </div>
      </FormGroup>
    </>
  );
};

FieldIgnoreCompletedStatus.propTypes = {
  form: PropTypes.object,
  dispatchServiceData: PropTypes.func,
}

export default FieldIgnoreCompletedStatus;
